export default __webpack_public_path__ + "static/media/fsk-15-a.0c954e37.jpg";